import { render, staticRenderFns } from "./adjustment-case-batch-allot.vue?vue&type=template&id=31af179c&scoped=true"
import script from "./adjustment-case-batch-allot.vue?vue&type=script&lang=ts"
export * from "./adjustment-case-batch-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af179c",
  null
  
)

export default component.exports